import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import { OtherService } from 'src/app/Service/other.service';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { ChartContext } from 'src/app/shared/chart/chart.models';
import { parseChartTree } from 'src/app/shared/chart/chart-data.utils';
import { CombinedChartKey } from './dashboard-combined.models';

@Component({
  selector: 'app-dashboard-combined',
  templateUrl: './dashboard-combined.component.html',
  styleUrls: ['./dashboard-combined.component.css'],
})
export class DashboardCombinedComponent implements OnInit {
  isLoading = false;
  hasLoadError = false;

  vehicleStatisticsChart: ChartContext = {
    type: 'tree', title: 'آمار خودروها به صورت کلی', data: [], loading: true,
  };

  vehicleStatusChart: ChartContext = {
    type: 'tree', title: 'وضعیت خودروهای سازمانی', data: [], loading: true,
  };

  vehicleViolationsChart: ChartContext = {
    type: 'tree', title: 'آمار تخلف خودروها', data: [], loading: true,
  };

  vehicleAverageLifeChart: ChartContext = {
    type: 'tree', title: 'متوسط عمر خودروها (سال)', data: [], loading: true,
  };

  vehicleRepairCostsChart: ChartContext = {
    type: 'tree', title: 'هزینه های تعمیراتی خودروها (میلیون تومان)', data: [], loading: true,
  };

  constructor(private router: Router, private otherService: OtherService, private gurdService: GurdServiceService) { }

  ngOnInit(): void {
    void this.loadDashboard();
  }

  async loadDashboard(): Promise<void> {
    if (this.isLoading) return;
    this.isLoading = true;
    this.hasLoadError = false;
    this.otherService.Showspinner();
    try {
      const results = await Promise.allSettled([
        this.loadTree('vehicleStatisticsChart', 'Tree_MobilesStatistics'),
        this.loadTree('vehicleStatusChart', 'Tree_MobilesStatus'),
        this.loadTree('vehicleViolationsChart', 'Tree_MobilesSerious'),
        this.loadTree('vehicleAverageLifeChart', 'Tree_MobilesAverageLife'),
        this.loadTree('vehicleRepairCostsChart', 'Tree_MobilesCostRpairs'),
      ]);
      this.hasLoadError = results.some(result => result.status === 'rejected');
    } finally {
      this.isLoading = false;
      this.otherService.nonespinner();
    }
  }

  private async loadTree(chartKey: CombinedChartKey, api: string): Promise<void> {
    this[chartKey] = { ...this[chartKey], loading: true, error: undefined };
    try {
      const model = {
        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      };
      const response = await axios.post(api, model);
      const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
      if (data?.ISSessionExpired === true || data?.ISessionExpired === true) {
        this.otherService.removeLocalStorage();
        void this.router.navigate(['login']);
        throw new Error('Dashboard session expired');
      }
      if (data?.iResult == 0) throw new Error(data.strError || 'Dashboard request failed');
      this[chartKey] = { ...this[chartKey], type: 'tree', data: parseChartTree(data) };
    } catch (error) {
      this[chartKey] = {
        ...this[chartKey],
        error: 'اطلاعات این نمودار دریافت نشد. دوباره به روز رسانی کنید.',
      };
      throw error;
    } finally {
      this[chartKey] = { ...this[chartKey], loading: false };
    }
  }

  guid(Id: any) {
    this.otherService.guid(Id);
  }

  goBack() {
    this.router.navigateByUrl('/');
  }
}
